import { SsoStartRequestSchema, SsoStartResponseSchema, SsoCallbackRequestSchema, SsoSignInResponseSchema, SsoLogoutRequestSchema, SsoLogoutResponseSchema, SsoStepUpRequestSchema, SsoStepUpResponseSchema } from './auth-sso.schema';
/**
 * SSO Start Endpoint Contract
 * Resolves the tenant for an email and returns either a Zitadel
 * authorization URL to redirect to, or `unknown` when the email maps
 * to no workspace.
 */ export const ssoStartContract = {
    method: 'POST',
    path: '/api/v2/auth/sso/start',
    description: 'Starts SSO login for an email, returns a Zitadel authorization URL or unknown mode',
    requestSchema: SsoStartRequestSchema,
    responseSchema: SsoStartResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body',
            503: 'Identity provider unreachable'
        }
    }
};
/**
 * SSO Callback Endpoint Contract
 * Exchanges the authorization code for tokens, verifies the identity and
 * signs the user in.
 */ export const ssoCallbackContract = {
    method: 'POST',
    path: '/api/v2/auth/sso/callback',
    description: 'Completes SSO login by exchanging the authorization code, returns JWT token and tenant',
    requestSchema: SsoCallbackRequestSchema,
    responseSchema: SsoSignInResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body',
            401: 'State expired or replayed, email mismatch, or code exchange failed',
            403: 'Authenticated but no active membership'
        }
    }
};
/**
 * SSO Step-Up Endpoint Contract
 * Authenticated (unlike the public siblings) because step-up derives email +
 * tenant scope from the verified session — re-auth must land back in the
 * SAME workspace, never wherever resolveByEmail would route.
 */ export const ssoStepUpContract = {
    method: 'POST',
    path: '/api/v2/auth/sso/step-up',
    description: 'Starts a forced re-authentication (max_age=0) for the current session, returns a Zitadel authorization URL',
    requestSchema: SsoStepUpRequestSchema,
    responseSchema: SsoStepUpResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid returnTo or session has no linked identity',
            401: 'Not authenticated',
            403: 'Identity disabled or membership revoked',
            503: 'Identity provider unreachable'
        }
    }
};
/**
 * SSO Logout Endpoint Contract
 * Local logout alone leaves the Zitadel session alive — the next email-first
 * login would silently sign the user back in. The frontend clears its local
 * session, then sends the browser to the returned end_session URL so the IdP
 * session dies too (RP-initiated logout, redirects back to /login).
 */ export const ssoLogoutContract = {
    method: 'POST',
    path: '/api/v2/auth/sso/logout',
    description: 'Returns the Zitadel end_session URL that terminates the IdP session and redirects back to the login page',
    requestSchema: SsoLogoutRequestSchema,
    responseSchema: SsoLogoutResponseSchema,
    // No error responses: every degraded case (no IdP configured, IdP
    // unreachable) answers a null logoutUrl — logout must never block.
    statusCodes: {
        success: 200,
        errors: {}
    }
};

//# sourceMappingURL=auth-sso.contract.js.map